import { reactive, set } from 'vue-demi';
const { useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('self-selected-stocks');

export default (props, stockList) => {
    const wchNumMap = reactive({});
    /* 添加了自选人数的数据 */
    const getNum = async (stock) => {
        const { stockId } = stock;
        const rsp = await request.get('wchNum', { stockId });
        const result = rsp?.data?.result || 0;
        set(wchNumMap, stock.stockId, result);
    };

    const initWchNum = () => {
        if (!stockList.value || !stockList.value.length) {
            return;
        }
        stockList.value.map(async (stock) => await getNum(stock));
    };

    return {
        wchNumMap,
        initWchNum,
    };
};
